var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 106,
    viewBox: "0 0 108 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E5E8FA",
    d: "M108 101c0 2.209-24.177 4-54 4s-54-1.791-54-4 24.177-4 54-4 54 1.791 54 4",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(0 1) matrix(1 0 0 -1 0 202)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M82.88 38H27.12C25.397 38 24 36.66 24 35.008v-.016C24 33.34 25.397 32 27.12 32h55.76c1.723 0 3.12 1.34 3.12 2.992v.016C86 36.66 84.603 38 82.88 38z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeWidth: 1.5,
    d: "M74.286 5.941L15.03 27.933c-.564.209-1.187-.087-1.392-.661l-.31-.868c-1.028-2.881.43-6.068 3.255-7.116L67.646.336c2.825-1.048 5.95.437 6.979 3.319l.31.867c.204.575-.086 1.21-.65 1.419z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#272C4D",
    strokeWidth: 1.5,
    d: "M52 6.096L32.602 13.2l-.329-.909c-.852-2.355.355-4.959 2.695-5.816l10.923-4c2.34-.857 4.928.357 5.78 2.712l.329.909z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeWidth: 1.5,
    d: "M70.423 101H38.577C36.601 101 35 99.229 35 97.044V96h39v1.044C74 99.23 72.399 101 70.423 101z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#272C4D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M73.751 96H35.25c-2.41 0-4.408-1.871-4.573-4.282L27 38h55l-3.676 53.718C78.16 94.128 76.161 96 73.751 96z",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#272C4D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M54.5 46L54.5 87M39 51L41 87M69 51L67 87",
    transform: "translate(-587 -187) translate(416 139) translate(171 48) translate(0 1)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTrash);
export default __webpack_public_path__ + "static/media/img-trash.4609b079c59b4fb43712cf7c5078ca13.svg";
export { ForwardRef as ReactComponent };